// extracted by mini-css-extract-plugin
export default {"button":"Vi-z","reviewSort":"Wi-z"};